import { Box, Grid } from '@material-ui/core'
import useStyles from '../styles'
import { isLastStep } from '../utils'
import AccessInstructions from './AccessInstructions'
import CoownerInfo from './CoownerInfo'
import TicketDescription from './TicketDescription'
import ViewWrapper from './ViewWrapper'

const TicketInformations = ({ record }) => {
  if (isLastStep(record) === true) {
    return null
  }
  const classes = useStyles()
  return (
    <Grid container justifyContent="center" className={classes.spacing}>
      <Grid item xs={11} md={6}>
        <Box
          style={{
            boxShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px',
            background: 'white',
            padding: '1rem',
          }}
        >
          <Grid container xs={12}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: '15px' }}>
              <TicketDescription record={record} />
            </Grid>
            <Grid item xs={12} sm={12}>
              <CoownerInfo record={record} />
            </Grid>
            <ViewWrapper record={record} />
            <Grid item xs={12} sm={12}>
              <AccessInstructions record={record} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default TicketInformations
